var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinLogoCircular15919(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.187 70.956 H 20.822 c -0.552 0 -1 -0.447 -1 -1 V 36.617 c 0 -0.552 0.448 -1 1 -1 h 10.365 c 0.552 0 1 0.448 1 1 v 33.339 C 32.187 70.509 31.739 70.956 31.187 70.956 z M 21.822 68.956 h 8.365 V 37.617 h -8.365 V 68.956 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.005 33.062 c -3.862 0 -7.005 -3.143 -7.005 -7.007 c 0 -3.866 3.143 -7.011 7.005 -7.011 s 7.005 3.145 7.005 7.011 C 33.01 29.919 29.867 33.062 26.005 33.062 z M 26.005 21.044 c -2.76 0 -5.005 2.248 -5.005 5.011 c 0 2.761 2.245 5.007 5.005 5.007 s 5.005 -2.246 5.005 -5.007 C 31.01 23.292 28.765 21.044 26.005 21.044 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70 70.956 H 59.643 c -0.553 0 -1 -0.447 -1 -1 V 53.743 c 0 -4.442 -0.323 -7.84 -4.385 -7.84 c -3.753 0 -5.215 2.121 -5.215 7.562 v 16.491 c 0 0.553 -0.447 1 -1 1 H 37.686 c -0.552 0 -1 -0.447 -1 -1 V 36.617 c 0 -0.552 0.448 -1 1 -1 h 9.939 c 0.553 0 1 0.448 1 1 v 1.753 c 1.918 -1.937 4.937 -3.58 8.945 -3.58 c 11.834 0 13.43 8.533 13.43 16.88 v 18.285 C 71 70.509 70.553 70.956 70 70.956 z M 60.643 68.956 H 69 V 51.671 c 0 -8.932 -1.943 -14.88 -11.43 -14.88 c -4.694 0 -7.739 2.613 -8.92 4.852 c -0.174 0.328 -0.514 0.533 -0.885 0.533 h -0.141 c -0.553 0 -1 -0.448 -1 -1 v -3.559 h -7.939 v 31.339 h 8.357 V 53.465 c 0 -2.615 0 -9.562 7.215 -9.562 c 6.385 0 6.385 6.16 6.385 9.84 V 68.956 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 2 C 21.29 2 2 21.29 2 45 c 0 23.71 19.29 43 43 43 c 23.71 0 43 -19.29 43 -43 C 88 21.29 68.71 2 45 2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogoCircular15919);
export default __webpack_public_path__ + "static/media/linkedin-logo-circular-15919.e4171589fdcd1b6d2ad62393b821ba77.svg";
export { ForwardRef as ReactComponent };